<template>
  <div class="class-performance-statistics">
    <table border="1" style="width: 98%; border-collapse: collapse; margin: 10px auto;">
      <thead>
        <tr style="background-color: #0066cc; color: #fff;">
          <th>班级</th>
          <th class="index">指标</th>
          <th v-for="(course, index) in courseNames" :key="index">{{ course }}</th>
          <th class="index">总分</th>
          <th class="index">排名</th>
        </tr>
      </thead>
      <tbody>
        <!-- 每个班级的数据 -->
        <template v-for="(classData, classIndex) in tableData">
          <tr :key="classIndex + '-header'">
            <td :rowspan="metrics.length" class="class-name">{{ classData.className }}</td>
            <td>{{ metrics[0] }}</td>
            <td v-for="(course, index) in courseNames" :key="index + 'avg'">{{
              getMetricValue(classData.courseAnalysis[index], metrics[0]) || '0' }}</td>
            <td :rowspan="metrics.length" class="class-name">{{ classData.totalScore || '0' }}</td>
            <td :rowspan="metrics.length" class="class-name">{{ classData.rank || '无' }}</td>
          </tr>
          <tr v-for="(metric, metricIndex) in metrics.slice(1)" :key="classIndex + '-' + metricIndex">
            <td>{{ metric }}</td>
            <td v-for="(course, index) in courseNames" :key="index + metric">{{
              getMetricValue(classData.courseAnalysis[index], metric) || '0' }}</td>
          </tr>
        </template>

        <!-- 全级的数据 -->
        <template v-if="totalRow">
          <tr :key="'total-header'">
            <td :rowspan="totalMetrics.length" class="class-name">{{ totalRow.className }}</td>
            <td>{{ totalMetrics[0] }}</td>
            <td v-for="(course, index) in courseNames" :key="index + 'avgTotal'">{{
              getMetricValue(totalRow.courseAnalysis[index], totalMetrics[0]) || '0' }}</td>
            <td :rowspan="metrics.length" class="class-name">{{ totalRow.totalScore || '无' }}</td>
            <td :rowspan="metrics.length" class="class-name">{{ totalRow.rank || '无' }}</td>
          </tr>
          <tr v-for="(metric, metricIndex) in totalMetrics.slice(1)" :key="'total-' + metricIndex">
            <td>{{ metric }}</td>
            <td v-for="(course, index) in courseNames" :key="index + metric">{{
              getMetricValue(totalRow.courseAnalysis[index], metric) || '0' }}</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ['classStatisticsData'],
  data() {
    return {
      // classStatisticsData: [/* 原始数据放这里 */]
    };
  },
  computed: {
    // 获取所有课程名称
    courseNames() {
      const allCourses = this.classStatisticsData.flatMap(item => item.courseAnalysis).map(course => course.courseName);
      return [...new Set(allCourses)]; // 使用Set去重
    },
    // 定义要显示的班级指标
    metrics() {
      return ['平均分', '不合格人数', '合格率', '优良率', '最高分', '最低分'];
    },
    // 定义要显示的全级指标
    totalMetrics() {
      return ['全级平均分', '全级平均合格率', '全级平均优良率', '全级最高分', '全级最低分'];
    },
    // 处理并返回表格所需的数据格式
    tableData() {
      return this.classStatisticsData
        .filter(item => item.className !== '全级')
        .map(item => ({
          className: item.className,
          rank: item.rank,
          totalScore: item.totalScore,
          courseAnalysis: this.formatCourseAnalysis(item.courseAnalysis),
          isTotal: false
        }));
    },
    // 提取全级的数据行
    totalRow() {
      const totalData = this.classStatisticsData.find(item => item.className === '全级');
      if (totalData) {
        return {
          className: totalData.className,
          courseAnalysis: this.formatCourseAnalysis(totalData.courseAnalysis),
          isTotal: true
        };
      }
      return null;
    }
  },
  methods: {
    // 格式化课程分析数据，确保每个班级都有所有课程的数据（即使某些课程为空）
    formatCourseAnalysis(courseAnalysis) {
      return this.courseNames.map(courseName => {
        const course = courseAnalysis.find(ca => ca.courseName === courseName);
        return course || {};
      });
    },
    // 根据给定的指标获取对应的值
    getMetricValue(course, metric) {
      // 如果course是空对象或者不存在特定属性，直接返回'-'
      // if (!course || !Object.keys(course).length || !course.hasOwnProperty(metric.toLowerCase().replace('全级', ''))) {
      //   return '-';
      // }

      switch (metric) {
        case '平均分':
        case '全级平均分': return course.averageScore !== undefined && course.averageScore != -1 ? course.averageScore : '-';
        case '不合格人数': return course.failCount !== undefined && course.failCount != -1 ? course.failCount : '-';
        case '合格率':
        case '全级平均合格率': return course.passRate !== undefined && course.passRate != -1 ? `${course.passRate}%` : '-';
        case '优良率':
        case '全级平均优良率': return course.excellentRate !== undefined && course.excellentRate != -1 ? `${course.excellentRate}%` : '-';
        case '最高分':
        case '全级最高分': return course.highestScore !== undefined && course.highestScore != -1 ? course.highestScore : '-';
        case '最低分':
        case '全级最低分': return course.lowestScore !== undefined && course.lowestScore != -1 ? course.lowestScore : '-';
        default: return '-';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./classPerformanceStatistics.scss";
</style>